import { render, staticRenderFns } from "./HeatmapFigure.vue?vue&type=template&id=59d20c6e&scoped=true"
import script from "./HeatmapFigure.vue?vue&type=script&lang=js"
export * from "./HeatmapFigure.vue?vue&type=script&lang=js"
import style0 from "./HeatmapFigure.vue?vue&type=style&index=0&id=59d20c6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d20c6e",
  null
  
)

export default component.exports